<script setup>
import { computed, ref, watch } from 'vue'
import { useFormStatusStore } from '~/stores/form-status.js'

const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
})

const isEditable = computed(() => useFormStatusStore().isEditable)
const store = useConveyancingCaseStore()

const normalize = (value) => (Array.isArray(value) ? value.map((v) => parseInt(v)).filter((v) => !Number.isNaN(v)) : [])

const selected = ref(normalize(props.context._value))

watch(
  () => props.context._value,
  (next) => {
    const normalized = normalize(next)
    if (JSON.stringify(normalized) !== JSON.stringify(selected.value)) {
      selected.value = normalized
    }
  },
  { deep: true },
)

watch(
  selected,
  (next) => {
    props.context.node.input([...next])
  },
  { deep: true },
)
</script>

<template>
  <el-form-item
    :label="context.attrs.title || 'Please select which client\'s funds should be used for the onwards purchase'"
    :required="context.state?.required"
    class="el-form-item--large"
  >
    <el-checkbox-group v-model="selected" :disabled="!isEditable" class="flex flex-col">
      <el-checkbox v-for="client in store.clients" :key="client.user_no" :value="parseInt(client.user_no)" :label="parseInt(client.user_no)">
        {{ client.name }}
      </el-checkbox>
    </el-checkbox-group>
  </el-form-item>
</template>

<style scoped></style>
